// Eskom PARCC — primary navigation.
//
// Reproduces the monolith's nav look (emoji + label, `.active` on the current
// item) using react-router `NavLink`, which sets `aria-current` and an active
// class for the matched route. Links are role-gated: admin sees everything;
// reviewer sees only the three shared screens (Dashboard, Transactions, Working
// Papers). This filtering is the navigation half of role gating; admin *routes*
// are independently guarded by <RequireRole> (so a deep link cannot bypass it).
//
// The link set is derived from APP_ROUTES — the single source of truth shared
// with the router (see ./routes) — so nav and route gating cannot drift.
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { canAccessRoute } from '../../lib/permissions';
import { APP_ROUTES } from './routes';

export function Nav(): React.JSX.Element {
  const { grant } = useAuth();

  // Each screen's visibility is decided by the capability model, keyed off the
  // route path. The router independently re-checks the same predicate
  // (RequireRoute) so a deep link cannot bypass nav filtering.
  const visible = APP_ROUTES.filter((route) => canAccessRoute(route.path, grant));

  return (
    <nav aria-label="Primary">
      {visible.map((route) => {
        const Icon = route.icon;
        return (
          <NavLink
            key={route.path}
            to={`/${route.path}`}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            <Icon size={15} aria-hidden className="nav-icon" />
            {route.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
